import { render, staticRenderFns } from "./ProductPricePreview.vue?vue&type=template&id=b1e30c26&"
import script from "./ProductPricePreview.vue?vue&type=script&lang=ts&"
export * from "./ProductPricePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports